export const columnFields = ['name', 'description'] as const;
